export const tr = {
    heading: "Direct'teki ilk kampanyanızı ayarlayalım",
    subheading: 'Kampanya ayarlarında yardıma ihtiyacınız varsa uzman hizmetlerini kullanın',
    'title-agency': 'Sertifikalı reklam ajansı seçme',
    'title-freelancer': 'Ayarlamaların yapılması için özel uzman seçme\r',
    'title-yandex': 'Yandex uzmanından reklam ayarlarını edinme'
};
